'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _Reflect$construct = require('@babel/runtime-corejs3/core-js-stable/reflect/construct');
var _createClass = require('@babel/runtime-corejs3/helpers/createClass');
var _classCallCheck = require('@babel/runtime-corejs3/helpers/classCallCheck');
var _possibleConstructorReturn = require('@babel/runtime-corejs3/helpers/possibleConstructorReturn');
var _getPrototypeOf = require('@babel/runtime-corejs3/helpers/getPrototypeOf');
var _inherits = require('@babel/runtime-corejs3/helpers/inherits');
var _defineProperty = require('@babel/runtime-corejs3/helpers/defineProperty');
var questionBase_model = require('./question-base.model.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var _Reflect$construct__default = /*#__PURE__*/_interopDefaultLegacy(_Reflect$construct);
var _createClass__default = /*#__PURE__*/_interopDefaultLegacy(_createClass);
var _classCallCheck__default = /*#__PURE__*/_interopDefaultLegacy(_classCallCheck);
var _possibleConstructorReturn__default = /*#__PURE__*/_interopDefaultLegacy(_possibleConstructorReturn);
var _getPrototypeOf__default = /*#__PURE__*/_interopDefaultLegacy(_getPrototypeOf);
var _inherits__default = /*#__PURE__*/_interopDefaultLegacy(_inherits);
var _defineProperty__default = /*#__PURE__*/_interopDefaultLegacy(_defineProperty);

function _callSuper(t, o, e) { return o = _getPrototypeOf__default["default"](o), _possibleConstructorReturn__default["default"](t, _isNativeReflectConstruct() ? _Reflect$construct__default["default"](o, e || [], _getPrototypeOf__default["default"](t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(_Reflect$construct__default["default"](Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }

/**
 * Vertex type and id information.
 *
 * @export
 * @interface VertexTypeAndId
 */

/**
 * Input one vertex.
 * - fixedVertexType: whether vertex type is fixed or flexible that need user to provide
 *
 * @export
 * @class InputVertexQuestion
 * @extends {QuestionBase<VertexTypeAndId>}
 */
var InputVertexQuestion = /*#__PURE__*/function (_QuestionBase) {
  function InputVertexQuestion() {
    var _this;
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    _classCallCheck__default["default"](this, InputVertexQuestion);
    _this = _callSuper(this, InputVertexQuestion, [options]);
    _defineProperty__default["default"](_this, "controlType", 'vertex');
    _this.fixedVertexType = !!options.fixedVertexType;
    return _this;
  }
  _inherits__default["default"](InputVertexQuestion, _QuestionBase);
  return _createClass__default["default"](InputVertexQuestion);
}(questionBase_model.QuestionBase);

exports.InputVertexQuestion = InputVertexQuestion;
